import { useState } from 'react';

import useDebounce from 'utils/useDebounce';

export default function useDebouncedValue<T>(initialValue: T, delay = 300) {
  const [liveValue, setLiveValue] = useState(initialValue);
  const debouncedValue = useDebounce(liveValue, delay);

  return [liveValue, setLiveValue, debouncedValue] as const;
}
